import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TemplateForm from '../../components/templates/TemplateForm';
import { createTemplate } from '../../api/client';

export default function TemplateCreate() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (payload) => {
    setError(null);
    setLoading(true);
    try {
      const created = await createTemplate(payload);
      const id = created?.id ?? created?._id?.$oid ?? created?._id;
      navigate(id ? `/templates/${id}/edit` : '/templates', { replace: true });
    } catch (err) {
      setError(err?.body?.message || err?.message || 'Failed to create template');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1 className="h4 mb-3">Create template</h1>
      <p className="text-muted mb-4">Add a new template with fields and tools.</p>
      <TemplateForm onSubmit={handleSubmit} loading={loading} error={error} />
    </div>
  );
}
